export default __webpack_public_path__ + "static/media/placeholder-image-square.2e600197.jpg";